<template>
  <TableBodyRow
    :thead="thead"
    class="gw_table_body_row_hoverable gw_hvr cursor_hover"
    @click="handleClick"
  >
    <TableBodyCell
      v-for="ii in [
        { val: item.name, id: 'name' },
        { val: $t(`solfigr.icm.full_name_${item.type}`), id: 'tournament_type' },
        { val: item.total_entrants, id: 'total_entrants' },
      ]"
      :key="ii.id"
      :data-tst="`${tstPrefix}_cell_${ii.id}`"
      :thKey="ii.id"
    >
      <div
        class="truncate"
        :title="ii.val"
      >
        {{ ii.val }}
      </div>
    </TableBodyCell>
    <TableBodyCell
      thKey="actions"
      style="z-index: 4"
    >
      <div
        class="d-flex gw_hvr_content"
        style="position: absolute; right: 0.25rem; z-index: 4"
      >
        <div
          v-if="hasDelete && !canDelete && !item_call.loading"
          style="--clr-back: var(--clr-error)"
          class="gw_btn text-medium weight_500 mr-1"
          :data-tst="`preset_delete_${item.name}`"
          @click.stop="canDelete = true"
        >
          <i class="mdi mdi-trash-can-outline"></i>
        </div>
        <div
          v-if="canDelete"
          class="d-flex"
          style="gap: 0.25rem"
          @click.stop
        >
          <div
            class="gw_btn text-small anim-fade-in"
            data-gwmenu="noclose"
            @click.stop="canDelete = false"
          >
            <div class="mdi mdi-close"></div>
          </div>
          <div
            class="gw_btn text-small anim-fade-in"
            style="--clr-back: var(--clr-error)"
            data-gwmenu="noclose"
            :data-tst="`ats_confirm_delete_${item.name}`"
            @click.stop="
              () => {
                canDelete = false
                $emit('delete:item', item)
              }
            "
          >
            <i class="mdi mdi-trash-can-outline mr-1"></i>
            {{ $t('btn.confirm') }}
          </div>
        </div>
        <div
          v-if="!canDelete"
          class="gw_btn text-medium weight_500"
          :data-tst="`${tstPrefix}_apply_btn`"
        >
          <div
            class="d-flex"
            :class="{ opacity_0: item_call.loading }"
          >
            <i class="mdi mdi-chevron-double-right mr-1"></i>
            {{ $t('btn.apply') }}
          </div>
          <LoaderSpinner
            v-if="item_call.loading"
            style="--size: 1.5rem; margin: auto; position: absolute"
          />
        </div>
      </div>
    </TableBodyCell>
  </TableBodyRow>
</template>

<script>
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import TableBodyRow from '@/components/DataTables/v2/TableBodyRow'
import TableBodyCell from '@/components/DataTables/v2/TableBodyCell'
import table_mix from '@/components/DataTables/table_mix'
import float_mix from '@/mixins/float_mix'
import fetch_mix from '@/mixins/fetch_mix'

export default {
  name: 'IcmStructuresTableRow',
  components: {
    TableBodyRow,
    TableBodyCell,
    LoaderSpinner,
  },
  mixins: [table_mix, float_mix, fetch_mix],
  props: {
    item: Object,
    thead: Object,
    tstPrefix: String,
    hasDelete: Boolean,
  },
  emits: ['click', 'delete:item'],
  data() {
    return {
      item_call: {
        conf: {
          endpoint: '',
          apiVersion: 'v4',
        },
        loading: false,
        loaded: false,
        status: 0,
      },
      canDelete: false,
    }
  },
  methods: {
    async handleClick() {
      if (this.item_call.loading) return
      this.item_call.conf.endpoint = `tournaments/${this.item.id}/`
      const { data, error } = await this.fch_getData(this.item_call)

      if (error) {
        this.$store.dispatch('messages', {
          type: 'error',
          text: this.$t(`messages.oops_error`),
        })
        return
      }

      this.$emit('click:item', { item: data })
    },
  },
}
</script>
